import { ModalContainerComponent } from './modal-container.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [ModalContainerComponent],
  exports: [ModalContainerComponent],
})
export class ModalModule {}
